import React, { useState, useEffect } from 'react';
import './CarsSearch.css';

import { carMakes, carTypes, carYears, carTransmissions, carFuelTypes, getCarModels, extractSearchParams, resetFormFields, handleSelectChange } from '../../utils/CarUtils';

import Select from 'react-select';
import { useLocation } from 'react-router-dom';



const CarSearch = ({ onFormSubmit }) => {

  const location = useLocation();

  // State variables for form fields
  const [carMake, setCarMake] = useState('');
  const [carModel, setCarModel] = useState('');
  const [carType, setCarType] = useState('');
  const [carYear, setCarYear] = useState('');
  const [transmission, setTransmission] = useState('');
  const [carFuelType, setCarFuelType] = useState('');
  const [maxPrice, setMaxPrice] = useState('');

  // Extract query parameters from the URL
  const queryParams = new URLSearchParams(location.search);

  useEffect(() => {
    // Extract search parameters using the custom function `extractSearchParams`
    const params = extractSearchParams(queryParams);

    // Update state values based on the extracted parameters
    setCarMake(params.carMake);
    setCarModel(params.carModel);
    setCarType(params.carType);
    setCarYear(params.carYear);
    setTransmission(params.transmission);
    setCarFuelType(params.carFuelType);
    setMaxPrice(params.maxPrice);

  }, [location.search]);

  // Handle form submission
  const handleFormSubmit = (e) => {
    e.preventDefault();
    onFormSubmit(carMake, carModel, carType, carYear, transmission, carFuelType, maxPrice);

    // Reset fields using extracted function
    resetFormFields([
      setCarMake, setCarModel, setCarType,
      setCarYear, setTransmission, setCarFuelType, setMaxPrice
    ]);
  };

  // Fetch available models based on selected car make
  const carModels = getCarModels(carMake);

  return (
    <section className="carSearch">
      <form className="car-search" onSubmit={handleFormSubmit}>

        {/* Car Make Selection */}
        <Select
          options={carMakes}
          value={carMakes.find((option) => option.value === carMake)}
          onChange={handleSelectChange(setCarMake)}
          className="custom-select box"
          classNamePrefix="custom-select-prefix"
          placeholder="Car Make"
        />

        {/* Car Model Selection */}
        <Select
          options={carModels}
          value={carModels.find((option) => option.value === carModel)}
          onChange={handleSelectChange(setCarModel)}
          className="custom-select box"
          classNamePrefix="custom-select-prefix"
          placeholder="Car Model"
        />

        {/* Car Type Selection */}
        <Select
          options={carTypes}
          value={carTypes.find((option) => option.value === carType)}
          onChange={handleSelectChange(setCarType)}
          className="custom-select box"
          classNamePrefix="custom-select-prefix"
          placeholder="Car Type"
        />

        {/* Car Year Selection */}
        <Select
          options={carYears}
          value={carYears.find((option) => option.value === carYear)}
          onChange={handleSelectChange(setCarYear)}
          className="custom-select box"
          classNamePrefix="custom-select-prefix"
          placeholder="Year"
        />

        {/* Transmission Selection */}
        <Select
          options={carTransmissions}
          value={carTransmissions.find((option) => option.value === transmission)}
          onChange={handleSelectChange(setTransmission)}
          className="custom-select box"
          classNamePrefix="custom-select-prefix"
          placeholder="Transmission"
        />

        {/* Car Fuel Type Selection */}
        <Select
          options={carFuelTypes}
          value={carFuelTypes.find((option) => option.value === carFuelType)}
          onChange={handleSelectChange(setCarFuelType)}
          className="custom-select box"
          classNamePrefix="custom-select-prefix"
          placeholder="Fuel Type"
        />

        {/* Max Price Input */}
        <div className="box">
          <input
            type="number"
            placeholder="Max Price"
            value={maxPrice}
            onChange={(e) => setMaxPrice(e.target.value)}
            className="input-field box"
            min="0"
          />
        </div>

        {/* Submit Button */}
        <div className="box">
          <button type="submit" className="btn">
            Search
          </button>
        </div>

      </form>
    </section>
  );
};

export default CarSearch;